<template>
    <component
        :is="pageTypeBanner"
        :page-type="pageType"
    />
</template>

<script setup>
    import HomeBanner from './HomeBanner.vue'
    import PageBanner from './PageBanner.vue'

    const { pageType } = storeToRefs(useGlobalStore())

    const pageTypeBanner = ref(null)

    onMounted(() => {
        if (pageType.value === 'home') {
            pageTypeBanner.value = markRaw(HomeBanner)
        } else {
            pageTypeBanner.value = markRaw(PageBanner)
        }
    })

</script>
